import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../hooks/useFetch";
import Swal from "sweetalert2";

// https://dev.to/bytebodger/constructors-in-functional-components-with-hooks-280m
// https://reactjs.org/docs/hooks-state.html
// https://beta.reactjs.org/reference/react/useRef
// https://ui.dev/react-router-pass-props-to-link

export default function Termo() {
    const navigate = useNavigate();
    const { get, post, put } = useFetch();
    const defaultState = {
        acao: "Visualizar",
        termo1: { id_palavra: "", palavra: "" },
        termo2: { id_palavra: "", palavra: "" }
    }

    /* objeto recebido do state={} do <Link> da página anterior
    ** https://v5.reactrouter.com/web/api/location  https://v5.reactrouter.com/web/api/Hooks/uselocation */
    let location = useLocation();

    // https://v5.reactrouter.com/web/example/url-params
    let { id1,id2 } = useParams();

    useEffect(() => {
        if (id1 === "criar" && id2 === "criar" )
            setState({ ...state, acao: "Criar" });
        else {
            buscarTermo(id1, id2).then(data => {
                // Aqui você pode manipular o 'data' antes de atualizar o estado 'termo'
                const {Termo1, Termo2, id_palavra1, id_palavra2} = data;

                const data1 = {
                    id_palavra: id_palavra1,
                    palavra : Termo1.palavra
                };
                const data2 = {
                    id_palavra: id_palavra2,
                    palavra: Termo2.palavra
                };

                setState({ ...state, termo1: data1, termo2: data2 });
            });
        }
    }, [id1, id2])

    async function buscarTermo(id1,id2) {
        try {
            let response = await get("/termo/" + id1 + '/' + id2);
            if (response.status === 200) {
                let dados = response.result.data;
                if (dados === null)
                    return defaultState;
                return dados;
            } else {
                return defaultState;
            }
        } catch (error) {
            console.error("Erro no buscarTermo():", error);
            return defaultState;
        }
    }

    /* https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    ** define o state inicial do componente, o useState retorna um array com 2 elementos, 
    ** objeto state e função setState pra atualizar o objeto state */
    const [state, setState] = useState(() => {
        // se a página anterior passou um state, retorna ele
        if (location.state) {
            if (location.state.acao) {
                defaultState.acao = location.state.acao;
            }
        }
        // senão, retorna um objeto vazio
        return defaultState;
    });

    /* https://reactjs.org/docs/hooks-reference.html#functional-updates
    ** handleChange: quando um campo do formulário é alterado, atualiza o objeto state */
    function changeTermo1(event) {
        let name = event.target.name; // name do campo que disparou o evento
        let value = event.target.value; // value do campo    

        // ex: se o campo com name Nome for alterado, atualiza o objeto state com o novo valor do campo Nome
        // { Nome: "novo valor do campo Nome" }
        setState(prevState => ({
            ...prevState,
            termo1: {
                ...prevState.termo1,
                [name]: value
            }
        }));
    }

    function changeTermo2(event) {
        let name = event.target.name; // name do campo que disparou o evento
        let value = event.target.value; // value do campo    

        // ex: se o campo com name Nome for alterado, atualiza o objeto state com o novo valor do campo Nome
        // { Nome: "novo valor do campo Nome" }
        setState(prevState => ({
            ...prevState,
            termo2: {
                ...prevState.termo2,
                [name]: value
            }
        }));
    }

    async function salvarTermo() {
        let method = state.acao === "Criar" ? post : put;
        try {
            let palavra1 = state.termo1.palavra
            let palavra2 = state.termo2.palavra
            let body = {
                palavra1: palavra1,
                palavra2: palavra2
            };
            
            let response;
            if(state.acao === "Criar") {
                response = await method(`/termo`, body);
            } else {
                response = await method(`/termo/${state.termo1.id_palavra}/${state.termo2.id_palavra}`, body);
            }
            if (response.status === 201 || response.status === 200) {
                navigate("/admin/termos");
            } else if (response.status === 400) {
                Swal.fire({
                    title: "Não foi possível salvar os termos",
                    text: "Os termos colocados já possuem uma relação existente",
                    icon: "error",
                })
            } else if (response.status === 600) {
                Swal.fire({
                    title: "Não foi possível salvar os termos",
                    text: "Termos colocados são iguais",
                    icon: "error",
                })
            }
            else {
                Swal.fire({
                    title: "Não foi possível salvar os termos",
                    text: "Erro ao salvar termos",
                    icon: "error",
                })
            }
        } catch (error) {
            console.error("Erro no salvarTermo():", error);
        }
    }

    return (
        <div className="admin-page-container">
            {/* Link de Retorno Moderno */}
            <div className="mb-4">
                <Link to="/admin/termos" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar aos Termos
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4">
                    {/* Título com Accent Visual */}
                    <div className="section-title-modern mb-4">
                        <div className="title-accent"></div>
                        <h2 className="admin-title">{state.acao} Relação de Termo</h2>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Termo Principal</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="input-moderno"
                                    name="palavra"
                                    placeholder="Ex: Estetoscópio"
                                    value={state.termo1.palavra ?? ""}
                                    onChange={changeTermo1}
                                    disabled={state.acao === "Visualizar"}
                                    maxLength={100}
                                />
                            </Form.Group>

                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Termo Relacionado (Sinônimo)</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="input-moderno"
                                    name="palavra"
                                    placeholder="Ex: Fonendoscópio"
                                    value={state.termo2.palavra ?? ""}
                                    onChange={changeTermo2}
                                    disabled={state.acao === "Visualizar"}
                                    maxLength={100}
                                />
                            </Form.Group>
                        </div>

                        {/* Botão de Ação Alinhado à Direita */}
                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvarTermo}>
                                    Salvar Alterações
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}